// Lib
import React, { ReactElement } from 'react';

// Selectors
import { selectIsMarkActive } from './selectors/tiptapToolSelectors';

// Hooks
import {
    useActiveTiptapEditorCallback,
    useTiptapActiveEditorSelector,
} from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from './RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

type StandardTiptapMarkToolProps = ToolbarToolProps & {
    mark: string;
};

const TiptapToggleMarkTool = (props: StandardTiptapMarkToolProps): ReactElement => {
    const { mark } = props;

    const isActive = useTiptapActiveEditorSelector(selectIsMarkActive(mark));

    const toggleMark = useActiveTiptapEditorCallback(
        (activeEditor, event: PointerEvent) => {
            if (!activeEditor) return;

            event.preventDefault();

            // Force focus back into the editor then toggle the mark
            activeEditor.commands.toggleMark(mark);
        },
        [mark],
    );

    return (
        <RichTextTool isActive={isActive} onClick={toggleMark} iconName={props.iconName || 'toolbar-bold'} {...props} />
    );
};

export default TiptapToggleMarkTool;
